import { Flags } from "@/classes/FeatureFlags";

const staffCanCreate = ({ role }) => role("admin") || role("user");

export const commandActions = [
    {
        id: "action.start-check",
        label: "Start a check",
        icon: "clipboard-check",
        route: "ChecksView",
        keywords: ["new check", "complete check", "check form"],
        description: "Choose an available check form",
        visible: (ctx) => ctx.has(Flags.ChecksModule) && staffCanCreate(ctx)
    },
    {
        id: "action.help-page",
        label: "Help for this page",
        icon: "question-circle",
        action: "help-page",
        keywords: ["help", "docs", "documentation", "guide", "how do i"],
        description: "Open the help article for the page you are on",
        visible: () => true
    },
    {
        id: "action.scan-label",
        label: "Trace a label",
        icon: "qrcode",
        // Opens the global scanner over the current page instead of routing
        // to a dedicated scan page, so the user keeps their place.
        action: "scan-label",
        keywords: ["identify", "scan", "barcode", "qr code", "pallet", "product"],
        description: "Scan a pallet, intake or product label and open the record",
        visible: (ctx) =>
            !ctx.role("supplier") &&
            (ctx.has(Flags.MeatModule) ||
                ctx.has(Flags.IngredientsModule) ||
                ctx.has(Flags.PackagingModule))
    },
    {
        id: "action.new-issue",
        label: "New issue",
        icon: "exclamation-triangle",
        route: "IssueCreate",
        keywords: ["create issue", "report problem", "corrective action"],
        visible: (ctx) => ctx.has(Flags.IssuesModule) && staffCanCreate(ctx)
    },
    {
        id: "action.new-complaint",
        label: "New complaint",
        icon: "comment-exclamation",
        route: "ComplaintCreate",
        keywords: ["create complaint", "supplier complaint"],
        visible: (ctx) =>
            ctx.has(Flags.ComplaintsModule) && (ctx.role("admin") || ctx.role("supplier"))
    },
    {
        id: "action.new-audit",
        label: "New audit",
        icon: "clipboard-list",
        route: "AuditCreate",
        keywords: ["create audit", "inspection"],
        visible: (ctx) => ctx.has(Flags.AuditModule) && staffCanCreate(ctx)
    },
    {
        id: "action.new-supplier",
        label: "Add supplier",
        icon: "industry-alt",
        route: "Settings",
        routeParams: { section: "suppliers" },
        routeQuery: { add: "supplier" },
        keywords: ["create supplier", "add vendor", "producer"],
        visible: (ctx) => ctx.has(Flags.SuppliersModule) && ctx.role("admin")
    },
    {
        id: "action.meat-intake",
        label: "New meat intake",
        icon: "drumstick-bite",
        route: "MeatIntakeView",
        keywords: ["receive meat", "goods in", "delivery"],
        visible: (ctx) => ctx.has(Flags.MeatModule) && staffCanCreate(ctx)
    },
    {
        id: "action.ingredient-intake",
        label: "New ingredient intake",
        icon: "wheat",
        route: "IngredientIntakeView",
        keywords: ["receive ingredients", "goods in", "delivery"],
        visible: (ctx) => ctx.has(Flags.IngredientsModule) && staffCanCreate(ctx)
    },
    {
        id: "action.packaging-intake",
        label: "New packaging intake",
        icon: "box-open",
        route: "PackagingIntakeForm",
        keywords: ["receive packaging", "goods in", "delivery"],
        visible: (ctx) => ctx.has(Flags.PackagingModule) && staffCanCreate(ctx)
    },
    {
        id: "action.delivery-intake",
        label: "New delivery",
        icon: "truck-loading",
        route: "DeliveryIntakeForm",
        keywords: ["receive delivery", "goods in", "intake"],
        visible: (ctx) => ctx.has(Flags.DeliveriesModule) && staffCanCreate(ctx)
    }
];

export function visibleCommandActions(ctx) {
    return commandActions.filter((action) => action.visible(ctx));
}
